import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationStore = defineStore('notification', () => {
  const message = ref('')
  const type = ref('success')
  const visible = ref(false)

  function showNotification(msg, notificationType = 'success') {
    message.value = msg
    type.value = notificationType
    visible.value = true
  }

  function hideNotification() {
    visible.value = false
  }

  return { message, type, visible, showNotification, hideNotification }
})
